import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import BookingOfInfrastructure from './booking-of-infrastructure.vue';

const MOUNT_ID = 'booking-of-infrastructure-vue';

interface BookingOpenParams {
  cluster?: string;
  premise?: string;
}

let bookingApp: App<Element> | null = null;

let bookingInstance: {
  open: (params?: BookingOpenParams) => void;
} | null = null;

let currentMountEl: HTMLElement | null = null;

let bookingTriggersInitialized = false;

function resolveMountRoot(root?: ParentNode): HTMLElement | null {
  const fromDom = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (fromDom) {
    return fromDom;
  }

  const dynamicMountEl = document.createElement('div');

  dynamicMountEl.id = MOUNT_ID;

  document.body.appendChild(dynamicMountEl);

  return dynamicMountEl;
}

function mountBookingModal(root?: ParentNode): void {
  const mountEl = resolveMountRoot(root);

  if (!mountEl) {
    return;
  }

  if (bookingApp && currentMountEl) {
    bookingApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(BookingOfInfrastructure);

  app.use(AntDesignVue);

  const instance = app.mount(mountEl) as unknown as {
    open: (params?: BookingOpenParams) => void;
  };

  bookingApp = app;
  bookingInstance = instance;
  currentMountEl = mountEl;
}

export function openBookingOfInfrastructure(params?: BookingOpenParams): void {
  if (!bookingApp || !bookingInstance) {
    mountBookingModal();
  }

  bookingInstance?.open(params);
}

export function initBookingTriggers(): void {
  if (bookingTriggersInitialized) {
    return;
  }

  bookingTriggersInitialized = true;

  mountBookingModal();

  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement | null;

    const trigger = target?.closest<HTMLElement>('[data-booking-open-modal]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    openBookingOfInfrastructure({
      cluster: trigger.dataset.cluster,
      premise: trigger.dataset.premise,
    });
  });
}
